const ContactInfo = {
     contact_phone: "+966562805932",
    contact_email: "umargul692002@gmail.com",
    contact_phone_zarrar: "+923029677678",
    contact_email_zarrar: "zararanwar1234321@gmail.com",
    address: "Riyadh, Saudi Arabia",

    
    facebook: "https://facebook.com",
    twitter: "https://facebook.com",
    linkedin: "https://facebook.com",
    instagram: "https://facebook.com",
    youtube: "https://facebook.com",
}


const teamMembers = [
    {id:1, name: "Alice Smith", title: "Project Manager" },
    {id:2, name: "Bob Johnson", title: "Software Engineer" },
    {id:3, name: "Catherine Lee", title: "UX Designer" },
    {id:4, name: "David Brown", title: "Data Analyst" },
    {id:5, name: "Emily Davis", title: "Marketing Specialist" },
    {id:6, name: "Frank Wilson", title: "Quality Assurance" },
    {id:7, name: "Grace Taylor", title: "Content Strategist" },
    {id:8, name: "Henry Moore", title: "DevOps Engineer" },
   
];

const server_ip = 'http://localhost:800'

export { ContactInfo, teamMembers, server_ip}